import Axios from "@/plugins/Axios";

class MatriculasService {
  async syncAll(pageNumber, query) {
    const response = await Axios().get(`matriculas?page=${pageNumber}&query=${query}`);
    return response.data;
  }

  async matricular(form) {
    form.matriculas = form.matriculas.map((matricula) => ({
      aluno_id: matricula.aluno_id,
      turma_id: matricula.turma_id,
      serie_id: matricula.serie_id,
      utiliza_transporte_publico: matricula.utiliza_transporte_publico, // Adiciona o campo utiliza_transporte_publico
      data_matricula: matricula.data_matricula, // Data da matrícula informada no formulário
    }));

    const response = await Axios().post("matriculas", form);
    const novaMatricula = response.data;
    return novaMatricula;
  }

  async transferirMatricula(form) {
    const response = await Axios().post("matriculas/transferir-matricula", form);
    return response.data;
  }

  async atualizarMatricula(matricula) {
    const response = await Axios().put(`matriculas/${matricula.id}`, matricula);
    const matriculaAtualizada = response.data;
    // store.commit("Matriculas/atualizarMatricula", matriculaAtualizada);
    return matriculaAtualizada;
  }

  async deletarMatricula(matricula) {
    const response = await Axios().delete(`matriculas/${matricula.id}`);
    const matriculaDeletada = response.data;
    // store.commit("Matriculas/deletarMatricula", matricula.id);
    return matriculaDeletada;
  }

  // async recuperarMatricula(matricula) {
  //   return this.atualizarMatricula({ ...matricula, deleted_at: null });
  // }

  async recuperarMatricula(matricula_id) {
    const response = await Axios().post(`matriculas/recuperar-matricula/${matricula_id}`);
    const matriculaAtualizada = response.data;
    return matriculaAtualizada;
  }

  async verificarMatriculaDuplicada(matricula_id) {
    const response = await Axios().post(`matriculas/verificar-matricula-duplicada/${matricula_id}`);
    const matriculaAtualizada = response.data;
    return matriculaAtualizada;
  }

  async ocultar(matricula) {
    const response = await Axios().get(`matriculas/ocultar/${matricula.id}`);
    const matriculaOcultado = response.data;
    // store.commit("Matriculas/atualizarMatricula", matriculaOcultado);
    return matriculaOcultado;
  }

  async verificarSeAlunoPossuiMatriculaNoMunicipio(aluno_id) {
    const response = await Axios().post(
      "matriculas/verificar-se-aluno-possui-matricula-no-municipio",
      { aluno_id }
    );
    return response.data;
  }

  async historico(aluno_id) {
    const response = await Axios().get(`matriculas/historico/${aluno_id}`);
    return response;
  }

  async getMediasdaMatricula(matricula_id) {
    const response = await Axios().get(
      `matriculas/desempenho-de-notas-do-aluno/matricula/${matricula_id}`
    );
    return response.data;
  }

  async getFaltasdaMatricula(matricula_id) {
    const response = await Axios().get(
      `matriculas/desempenho-de-faltas-do-aluno/matricula/${matricula_id}`
    );
    return response.data;
  }

  async qtd() {
    const response = await Axios().get("matriculas/qtd");
    return response.data;
  }

  async qtdPorFranquia(franquiaId) {
    const response = await Axios().get(`matriculas/qtdPorFranquia/${franquiaId}`);
    return response.data;
  }

  async taxaEvasao(franquiaId) {
    const response = await Axios().get(`matriculas/taxaEvasao/${franquiaId}`);
    return response.data;
  }

  async pegarMatricula(matricula_id) {
    const response = await Axios().get(`matriculas/pegar-matricula/${matricula_id}`);
    return response.data;
    // store.commit("Matriculas/atualizarMatricula", matriculaOcultado);
  }

  async migrarMatriculas(turmaId, matriculasSelecionadas, serieId = null) {
    const response = await Axios().post(`matriculas/migrar-matriculas/${turmaId}`, {
      matriculas: matriculasSelecionadas,
      serie_id: serieId,
    });
    return response.data;
  }
}

export default new MatriculasService();
